import { render } from "./ServerView.vue?vue&type=template&id=08d58150&scoped=true"
import script from "./ServerView.vue?vue&type=script&lang=js"
export * from "./ServerView.vue?vue&type=script&lang=js"

import "./ServerView.vue?vue&type=style&index=0&id=08d58150&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d58150"]])

export default __exports__